import React from 'react'
import {
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton
} from 'react-share'
import twitterIcon from '../../images/Twitter.svg'
import facebookIcon from '../../images/Facebook.svg'
import linkedinIcon from '../../images/LinkedIn.svg'
import { useLocation } from '@reach/router'
import Image from '../../function/Image'

const platforms = {
    Twitter: TwitterShareButton,
    Facebook: FacebookShareButton,
    Linkedin: LinkedinShareButton
}
const SocialMediaBlock = ({ socialMediaBlock }) => {
    const { socialMedia } = socialMediaBlock || {}
    const location = useLocation()

    const backgroundStyles = (background) => {
        if (!background) return

        if (background?.solidColor) {
            return { backgroundColor: background?.solidColor }
        }

        if (
            background?.gradientColor?.firstColor &&
            background?.gradientColor?.secondColor
        ) {
            return {
                background: `transparent linear-gradient(135deg, ${background?.gradientColor?.firstColor} 0%, ${background?.gradientColor?.secondColor} 100%) 0% 0% no-repeat padding-box`
            }
        }
    }
    return (
        <div className="container social-media-block">
            <div className="flex gap-x-[10px]">
                {socialMedia?.map((social, index) => {
                    const Component = platforms[social?.sharingPlatform]
                    return (
                        <Component url={location.href} key={index}>
                            <div
                                className="bg-gradient-to-br from-sea_serpent to-han_purple grid place-items-center rounded-full w-10 !p-3 aspect-square hover:from-[#3C9798] hover:to-[#4423BC]"
                                style={backgroundStyles(social?.background)}
                            >
                                <Image {...social?.icon} />
                            </div>
                        </Component>
                    )
                })}
            </div>
        </div>
    )
}

export default SocialMediaBlock
